export default class DeviceType {
  static readonly pro: string = '001'
  static readonly deep: string = '002'
  static readonly swash: string = '003'
}

export const devices: any = {
  '001': {
    type: '001',
    name: 'CARE PRO professional',
  },
  '002': {
    type: '002',
    name: 'CARE PRO DEEP',
  },
  '003': {
    type: '003',
    name: 'CARE PRO SWaSH',
  },
}

export function getDeviceInfo(deviceType: string | undefined) {
  if (deviceType) return devices[deviceType]
  return {
    name: '未定義',
  }
}
